<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">电费账单</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-upload2" class="s-btn-exp" @click="exportfile">导出</el-button>
                <el-button icon="el-icon-plus" type="primary" class="s-btn-add" @click="editElectric">添加电费账单</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" id="leSearch">
                <le-select-remote-search label="电费项目" multiple reserveKeyword v-model="pageParam.params.projectIdList" :options="optionsElectric" placeholder="请选择电费项目(可搜索)" />
                <le-select-remote-search label="电费站点" multiple reserveKeyword v-model="pageParam.params.stationIdList" :options="optionsStation" placeholder="请选择站点(可搜索)" />
                <le-select-remote-search label="电表号" multiple reserveKeyword v-model="pageParam.params.ammeterIdList" :options="optionsAmmeter" placeholder="请选择电表(可搜索)" />
                <le-select-local-search label="缴费状态" v-model="pageParam.params.payStatusList" multiple :options="payStatusDic" />
                <le-input label="凭证号" v-model="pageParam.params.voucherNumber" />
                <le-input label="请款单号" v-model="pageParam.params.payRollNumber" />
                <le-input label="账单编号" v-model="pageParam.params.id" />
                <le-select-local-search label="付款方式" v-model="pageParam.params.chargeFeeType" :options="chargeFeeTypeDic" />
                <le-select-local-search label="账单类型" v-model="pageParam.params.billType" :options="billTypeDic" />
                <le-date-range label="计费/抄表起始时间" :minDate.sync="pageParam.params.lastStartDate" :maxDate.sync="pageParam.params.lastEndDate" valueFormat="yyyy-MM-dd HH:mm:ss" :defaultTime="['00:00:00','23:59:59']" />
                <le-date-range label="计费/抄表终止时间" :minDate.sync="pageParam.params.startDate" :maxDate.sync="pageParam.params.endDate" valueFormat="yyyy-MM-dd HH:mm:ss" :defaultTime="['00:00:00','23:59:59']" />
            </le-search-form>
            <le-pagview 
                ref="electricBillListPage" 
                @setData="setTableData" 
                :pageParam="pageParam" 
                :isFixed="true" 
                :tableRef="$refs.electricBillList" 
                :pageSizeDefault='20'>
                <template slot="headerLabel" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <el-button size='mini' type="primary" plain @click="handleDeleteCancelAll">取消批量</el-button>
                        <el-button size='mini' type="primary" @click="handleSetPZ('', 'batch')">确认选择</el-button>
                        <span class="a-ml-20 a-fs-12 a-fw-700">共选择{{ selectData.length }}个账单</span>
                    </div>
                </template>
                <el-table 
                    ref="electricBillList" 
                    :data="tableData" 
                    :highlight-current-row="true" 
                    :row-key="getRowKey"
                    @selection-change="handleSelectionChange"
                    v-sticky="{ top: 0, parent:'.el-card__body' }" 
                    style="width: 100%">
                    <el-table-column type="selection" fixed="left" align="center" width="55" reserve-selection  class="device-checkBox"></el-table-column>
                    <el-table-column prop="projectId" label="账单编号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.id || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectId" label="电费项目" min-width="150">
                        <template slot-scope="{ row }">
                            <!-- <span>{{ row.projectName || '-' }}</span> -->
                            <el-popover
                                placement="top-start"
                                title="电费项目"
                                width="400"
                                trigger="hover">
                                <div class="a-flex-cfsfs">
                                    <span class="a-fs-13 a-mt-10" v-for="(item,index) in row.projectNameList" :key="index">{{ index+1 }}. {{ item }}</span>
                                </div>
                                <div slot="reference" class="textOver1" style="width: 140px;display: block !important">{{ row.projectNameListStr || '-' }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stationId" label="电费站点" width="150">
                        <template slot-scope="{ row }">
                            <el-popover
                                placement="top-start"
                                title="电费站点"
                                width="400"
                                trigger="hover">
                                <div class="a-flex-cfsfs">
                                    <span class="a-fs-13 a-mt-10" v-for="(item,index) in row.stationNameList" :key="index">{{ index+1 }}. {{ item }}</span>
                                </div>
                                <div slot="reference" class="textOver1" style="width: 140px;display: block !important">{{ row.stationNameListStr || '-' }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ammeterId" label="电表号" width="130">
                        <template slot-scope="{ row }">
                            <el-popover
                                placement="top-start"
                                title="电表号"
                                width="200"
                                trigger="hover">
                                <div class="a-flex-cfsfs">
                                    <span class="a-fs-13 a-mt-10" v-for="(item,index) in row.ammterNoList" :key="index">{{ index+1 }}. {{ item }}</span>
                                </div>
                                <div slot="reference" class="textOver1" style="width: 120px;display: block !important">{{ row.ammterNoListStr || '-' }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ammeterId" label="账单类型" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.billType | initDic(billTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ammeterId" label="付款方式" min-width="120">
                        <template slot-scope="{ row }">
                            <span v-if="row.billType == 1 || row.billType == 3">{{ row.chargeFeeType | initDic(chargeFeeTypeDic) }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderPrice" label="剩余金额" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>剩余金额</span>
                                <el-tooltip class="item" effect="dark" content="预充值账单的上期剩余费用" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span v-if="row.chargeFeeType == 1 && (row.billType == 1 || row.billType == 3)">￥{{ util.numFormat(row.lastRemainMoney || 0) }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderPrice" label="本期应付" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>本期应付</span>
                                <el-tooltip class="item" effect="dark" content="账单的合计应付电费。后付费：即本期电费；预付费：即本次预交的费用" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.totalPay || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderPrice" label="本期已付" min-width="123">
                        <template slot="header" slot-scope="scope">
                            <div class="a-flex-rfsc">
                                <span>本期已付</span>
                                <el-tooltip class="item" effect="dark" content="已经记录了缴费的部分" placement="top">
                                    <span class="el-icon-question"></span>
                                </el-tooltip>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.payAmount || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceNumId" label="缴费状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.payStatus | initDic(payStatusDic) }}</span>
                            <!-- <el-tooltip placement="top">
                                <div slot="content">多行信息<br/>第二行信息</div>
                                <span class="el-icon-info"></span>
                            </el-tooltip> -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastRecordTimeId" label="计费/抄表起始时间" min-width="160">
                        <template slot-scope="{ row }">
                            <span>{{ row.billDateStart || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="recordTimeId" label="计费/抄表终止时间" min-width="160">
                        <template slot-scope="{ row }">
                            <span>{{ row.billDate || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalPowerId" label="应结算度数（kwh）" min-width="140">
                        <template slot-scope="{ row }">
                            <span v-if="row.billType == 1 || row.billType == 3">{{ row.totalEnergy || 0 }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="predictEnergyId" label="预估度数（kwh）" min-width="140">
                        <template slot-scope="{ row }">
                            <span v-if="row.billType == 1 || row.billType == 3">{{ row.predictEnergy || 0 }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="unitPriceId" label="单价(/元/kwh)" min-width="140">
                        <template slot-scope="{ row }">
                            <span v-if="row.billType == 1 || row.billType == 3">￥{{ util.numFormat5(row.unitPrice || 0) }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="unitPriceId" label="账单单价(/元/kwh)" min-width="140">
                        <template slot-scope="{ row }">
                            <span v-if="row.billType == 1 || row.billType == 3">￥{{ util.numFormat5(row.billUnitPrice || 0) }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="needPayAmountId" label="区间费用" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.totalIntervalFee || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalIncomeId" label="区间收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.totalProfit || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intervalIncomeId" label="区间电费占比" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.ratio || 0) }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalProfitId" label="凭证号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.voucherNumber || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalProfitId" label="请款单号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.payRollNumber || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalProfitId" label="备注" min-width="120">
                        <template slot-scope="{ row }">
                            <el-tooltip placement="top">
                                <div slot="content" style="max-width: 300px">{{ row.remark || '-' }}</div>
                                <span class="textOver1">{{ row.remark || '-' }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pid" label="操作" width="170" fixed="right">
                        <template slot-scope="{ row }">
                            <!-- <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <img src="../../assets/icon/option-refuse.png" class="a-wh-16" @click="electricBillDelete(scope.row)" v-if="scope.row.isNew" />
                            </el-tooltip> -->
                            <el-button type="text" @click="electricBillInfo(row)">详情</el-button>
                            <el-button type="text" @click="handleToPay(row)" v-if="row.payStatus != 2">付款</el-button>
                            <el-button type="text" @click="handleSetPZ(row, '')">编号管理</el-button>
                            <el-button type="text" @click="electricBillDelete(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            <!-- <div style="height: 16px"></div> -->

                <!-- <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-cfsfs">
                        <div class="a-flex-rfsc">
                            <div class="a-flex-rfsc" style="margin-right: 40px">
                                <span class="a-fs-12 a-c-normal">本期应付金额：</span>
                                <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(totalPay)}}</span>
                            </div>
                            <div class="a-flex-rfsc">
                                <span class="a-fs-12 a-c-normal">本期应付度数：</span>
                                <span class="a-fs-16 a-c-master a-fw-b">{{totalEnergy || 0}}kwh</span>
                            </div>
                        </div>
                        <div class="a-flex-rfsc">
                            <div class="a-flex-rfsc" style="margin-right: 40px">
                                <span class="a-fs-12 a-c-normal">搜索时间内应付金额：</span>
                                <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.intervalPay)}}</span>
                            </div>
                            <div class="a-flex-rfsc">
                                <span class="a-fs-12 a-c-normal">搜索时间内应付度数：</span>
                                <span class="a-fs-16 a-c-master a-fw-b">{{scope.val.intervalPower || 0}}kwh</span>
                            </div>
                        </div>
                    </div>
                </template> -->
            </le-pagview>
        </el-card>
        <electric-bill-pay ref="payBill" @change="handlePaySuccess"></electric-bill-pay>
        <bill-num-edit ref="billNumEdit" @change="handlePaySuccess"></bill-num-edit>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    import BillNumEdit from './bill-info-child/bill-num-edit.vue'
    import electricBillPay from './child/electric-bill-pay.vue'
    export default {
        components: { electricBillPay, BillNumEdit },
        data () {
            return {
                util: util,
                tableData: [],
                pageParam: {
                    url: this.$Config.apiUrl.electricBillRecord,
                    method: "post",
                    params: {
                        "ammeterIdList": [],
                        "chargeFeeType": '',
                        "endDate": "",
                        "id": '',
                        "payStatusList": this.$route.query.payStatus ? JSON.parse(this.$route.query.payStatus) : [],
                        "projectIdList": this.$route.query.projectId ? [Number(this.$route.query.projectId)] : [],
                        "startDate": "",
                        "stationIdList": [],
                        "voucherNumber": "",
                        payRollNumber: '',
                        billType: '',
                        lastStartDate: '',
                        lastEndDate: ''
                    },
                    freshCtrl: 1,
                },
                optionsStation: {
                    url: this.$Config.apiUrl.getStationList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "stationId",
                    searchKey: "name",
                },//站点数据
                optionsElectric: {
                    url: this.$Config.apiUrl.electricFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                },
                optionsAmmeter: {
                    url: this.$Config.apiUrl.ammeterFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                },
                totalEnergy: '',//本期应付总电量
                totalPay: '',//本期应付总金额
                payStatusDic: [],
                chargeFeeTypeDic: [],
                selectData: [],
                billTypeDic: [{
                    label: '全部',
                    value: ''
                },{
                    label: '电费',
                    value: '1'
                },{
                    label: '服务费',
                    value: '2'
                },{
                    label: '电费+服务费',
                    value: '3',
                    show: false
                }]
            }
        },
        created () {
            this.$getDic('billPayStatus','select').then(res=>{ this.payStatusDic = res; })
            this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        },
        activated () {
            this.pageParam.freshCtrl++;
        },
        methods:{
            //获取列表
            setTableData(datas) {
                this.tableData = datas.map(item=>{
                    let ammterNoList = item.ammterNoList ? [...new Set(JSON.parse(item.ammterNoList))] : []
                    let stationNameList = item.stationNameList ? [...new Set(JSON.parse(item.stationNameList))] : []
                    let projectNameList = item.projectName ? [...new Set(JSON.parse(item.projectName))] : []
                    return {
                        ...item,
                        ammterNoList: ammterNoList,
                        ammterNoListStr: ammterNoList.join('、'),
                        stationNameList: stationNameList,
                        stationNameListStr: stationNameList.join('、'),
                        projectNameList: projectNameList,
                        projectNameListStr: projectNameList.join('、')
                    }
                })
            },
            handlerRest() {
                this.pageParam.params = {
                    "ammeterIdList": [],
                    "chargeFeeType": '',
                    "endDate": "",
                    "id": '',
                    "payStatusList": [],
                    "projectIdList": [],
                    "startDate": "",
                    "stationIdList": [],
                    "voucherNumber": "",
                    "payRollNumber": '',
                    "billType": '',
                    lastStartDate: '',
                    lastEndDate: ''
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['electricBillList'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            getRowKey (row) {
                return row.id
            },
            handleSelectionChange (selection) {
                this.selectData = selection
            },
            // 添加电费账单
            editElectric () {
                this.$router.push({
                    path: '/electric/electric-charge-add',
                })
            },
            handleToPay (datas) {
                this.$refs['payBill'].billInfo = datas
                this.$refs['payBill'].dialogVisible = true
            },
            handlePaySuccess () {
                this.pageParam.freshCtrl++;
            },
            handleSetPZ (datas, type) {
                let ids = [], voucherNumber = '', payRollNumber = ''
                if(type == 'batch') {
                    if(!this.selectData.length) {
                        this.$message.error('请至少选择一条账单')
                        return
                    }
                    ids = this.selectData.map(item=>{
                        return item.id
                    })
                }else {
                    ids = [datas.id]
                    voucherNumber = datas.voucherNumber ? datas.voucherNumber : ''
                    payRollNumber = datas.payRollNumber ? datas.payRollNumber : ''
                }
                this.$refs["billNumEdit"].form.voucherNumber = voucherNumber
                this.$refs["billNumEdit"].form.payRollNumber = payRollNumber
                this.$refs["billNumEdit"].idList = ids
                this.$refs["billNumEdit"].dialogVisible = true
            },
            handleDeleteCancelAll () {
                this.$refs['electricBillList'].clearSelection()
                this.selectData = []
            },
            electricBillDelete (datas) {
                this.$confirm('是否确认删除？','温馨提示')
                .then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.electricBillDelete,
                        method: "post",
                        params: {
                            billId: datas.id
                        }
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.pageParam.freshCtrl++;
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                })
                .catch(_=>{})
            },
            electricBillInfo (datas) {
                this.$router.push({
                    path: '/electric/electric-bill-info',
                    query:{
                        id: datas.id,
                    }
                })
            },
            exportfile () {
                let startDate = this.pageParam.params.startDate || this.$getDay.getTodayBeforeDays(92) + ' 00:00:00'
                let endDate = this.pageParam.params.endDate || this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
                this.$exfile({
                    code: 35,
                    fileName: `${startDate.split(' ')[0]} 至 ${endDate.split(' ')[0]}电费账单`,
                    startTime: startDate,
                    endTime: endDate,
                    params: {
                        ...this.pageParam.params,
                        startDate: startDate,
                        endDate: endDate
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.s-btn-add{
    width: 135px;
}
/deep/ .s-search-label{
    width: 100px
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
.alertInfoWarning{
    color: #E6A23C;
}
.alertInfoError{
    color: #F56C6C;
}
</style>